import type { UpsertQuizQuestion } from "@/generated/graphql";

export type IQuestionListItem = {
  question: UpsertQuizQuestion;
};

export type IValidationStatus = {
  isValid: boolean;
  message: string;
};

export enum CardPriority {
  Normal = "normal",
  Incoming = "incoming",
  Urgent = "urgent",
  Unavailable = "unavailable",
}
